import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusLivePrivacyPolicyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EpocusLivePrivacyPolicyQuery = { readonly __typename?: 'Query', readonly epocusLivePrivacyPolicy?: { readonly __typename?: 'EpocusPrivacyPolicy', readonly id: string, readonly version: number, readonly bodyText: string, readonly effectiveFrom: string } | null };


export const EpocusLivePrivacyPolicyDocument = gql`
    query EpocusLivePrivacyPolicy {
  epocusLivePrivacyPolicy {
    id
    version
    bodyText
    effectiveFrom
  }
}
    `;

/**
 * __useEpocusLivePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `useEpocusLivePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusLivePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusLivePrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpocusLivePrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<EpocusLivePrivacyPolicyQuery, EpocusLivePrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusLivePrivacyPolicyQuery, EpocusLivePrivacyPolicyQueryVariables>(EpocusLivePrivacyPolicyDocument, options);
      }
export function useEpocusLivePrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusLivePrivacyPolicyQuery, EpocusLivePrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusLivePrivacyPolicyQuery, EpocusLivePrivacyPolicyQueryVariables>(EpocusLivePrivacyPolicyDocument, options);
        }
export type EpocusLivePrivacyPolicyQueryHookResult = ReturnType<typeof useEpocusLivePrivacyPolicyQuery>;
export type EpocusLivePrivacyPolicyLazyQueryHookResult = ReturnType<typeof useEpocusLivePrivacyPolicyLazyQuery>;
export type EpocusLivePrivacyPolicyQueryResult = Apollo.QueryResult<EpocusLivePrivacyPolicyQuery, EpocusLivePrivacyPolicyQueryVariables>;